module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/dinner-37b7d620c7163942060872b06c655932.svg";